import { useEffect, useState } from "react";
import SortableTable from "../../../Table/SortableTable";
import { TableColumn } from "../../../../types/Table/TableColumns";
import { TableAction } from "../../../Table/TableAction";
import { useLayerAdminService, useLayerService } from "../../../../hooks";
import { RouteLineImport } from "../../../../types/RouteLine/RouteLineImport";
import LayerService from "../../../../services/LayerService";
import useRouteLineService from "../../../../hooks/useRouteLineService";

interface RouteLineRow {
  id: number;
  importQuarter: string;
  createDate: string;
  publishDate: string | null;
}

const DeleteQuarter = () => {
  const [loading, setLoading] = useState(false);
  const layerService = useLayerService();
  const routeLineService = useRouteLineService();
  const [quarters, setQuarters] = useState<RouteLineRow[]>([]);

  useEffect(() => {
    loadQuarters();
  }, []);

  const loadQuarters = () => {
    setLoading(true);
    layerService.GetRouteLineImportQuarters().then((data) => {
      setQuarters(
        data.map((item) => ({
          id: item.id,
          importQuarter: item.importQuarter,
          createDate: item.createDate?.toFormat("dd/LL/yyyy, HH:mm:ss"),
          publishDate:
            item.publishDate?.toFormat("dd/LL/yyyy, HH:mm:ss") || null,
        }))
      );
      setLoading(false);
    });
  };

  const onDelete = (row: RouteLineRow) => {
    routeLineService.deleteRouteLine(row.id.toString()).then(() => {
      loadQuarters(); // re-fetch
    });
  };

  const actions = [
    {
      content: "Delete",
      onClick: onDelete,
      show: true,
    },
  ] as TableAction[];

  const cols = [
    {
      displayName: "Quarter",
      field: "importQuarter",
    },
    {
      displayName: "Created",
      field: "createDate",
    },
    {
      displayName: "Published",
      field: "publishDate",
    },
  ] as TableColumn[];

  return (
    <SortableTable
      height="auto"
      columns={cols}
      data={quarters}
      loading={loading}
      actions={actions}
    />
  );
};

export default DeleteQuarter;
